"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_RESTRICTED_MESSAGE = exports.ERROR_RESTRICTED_CODE = exports.BAD_REQUEST_MESSAGE = exports.BAD_REQUEST_STATUS = exports.ACCEPTED_REQUEST_STATUS = exports.SUCCESS_REQUEST_STATUS = void 0;
// (C) 2019 GoodData Corporation
exports.SUCCESS_REQUEST_STATUS = 200;
exports.ACCEPTED_REQUEST_STATUS = 202;
exports.BAD_REQUEST_STATUS = 400;
exports.BAD_REQUEST_MESSAGE = "Bad Request";
exports.ERROR_RESTRICTED_CODE = "Export to required format is not allowed for data flagged as restricted.";
exports.ERROR_RESTRICTED_MESSAGE = "You cannot export this insight because it contains restricted data.";
//# sourceMappingURL=errors.js.map